import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';
import { KycRenewalService } from 'src/app/services/kyc-renewal.service';
import { ProfileService } from 'src/app/services/profile.service';
import { kycRenewalText } from 'src/app/shared/kyc-renewal.texts';
import { isKycRenewalExpired, mustRenewKyc, Profile } from 'src/app/shared/models/register.models';

// Aviso de renovación del KYC: desde unos días antes de la fecha límite y, pasada, hasta que la renueva
@Component({
  selector: 'fun-kyc-renewal-banner',
  templateUrl: './kyc-renewal-banner.component.html',
})
export class KycRenewalBannerComponent implements OnInit {

  profile: Profile;
  text: string;
  btnTitle: string;
  expired = false;
  // Al terminar la verificación se oculta: el perfil sigue igual hasta que llega el webhook de Mangopay
  renewed = false;

  constructor(
    private storage: Storage,
    private profileService: ProfileService,
    private kycRenewalService: KycRenewalService,
    private translate: TranslateService,
    private chdRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    // Se pinta ya con el perfil guardado en el login y se refresca con el del back (puede haber renovado)
    this.storage.get('PROFILE').then((stored: Profile) => {
      if (!stored?.username) { return; }
      this.setProfile(stored);
      this.profileService.getProfile(stored.username).subscribe((profile: Profile) => {
        this.setProfile(profile);
        this.kycRenewalService.updateStoredStatus(profile?.kycRenewalStatus, profile?.kycRenewalDeadline);
      });
    });
  }

  private setProfile(profile: Profile) {
    this.profile = profile;
    this.expired = isKycRenewalExpired(profile);
    this.text = kycRenewalText(this.translate, this.expired ? 'KYC_RENEWAL.BANNER_EXPIRED' : 'KYC_RENEWAL.BANNER_UPCOMING',
      { date: this.kycRenewalService.formatDeadline(profile?.kycRenewalDeadline) });
    this.btnTitle = kycRenewalText(this.translate, 'KYC_RENEWAL.BTN');
    this.chdRef.detectChanges();
  }

  get visible(): boolean {
    return !this.renewed && mustRenewKyc(this.profile);
  }

  renew() {
    this.kycRenewalService.openRenewalModal(this.profile.username).subscribe(() => {
      this.renewed = true;
      this.chdRef.detectChanges();
    });
  }
}
